import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import MonthlySalaryReportFilters from "./components/MonthlySalaryReportFilters";
import MonthlySalaryReportTable from "./components/MonthlySalaryReportTable";
import { fetchMonthlySalaryReport } from "./MonthlySalaryReportThunk";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportMonthlySalaryReportCsv } from "./components/exportMonthlySalaryReportCsv";

const { Title } = Typography;

const MonthlySalaryReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
const { filters, list } = useSelector((state) => state.monthlySalaryReport); // â† added list

  useEffect(() => {
    dispatch(fetchMonthlySalaryReport({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Monthly Salary Payable Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportMonthlySalaryReportCsv({
      list,
      filters,
      title:    "Monthly Salary Payable Report",
      filename: "monthly_salary_report",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Flex align="center">
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                onClick={() => navigate(-1)}
                style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
                data-testid="monthly-salary-report-back-button"
              />
              <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >
                Monthly Salary Payable Report
              </Title>
            </Flex>
          }
         extra={
            // â† replaced single Button with Flex + two buttons
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <MonthlySalaryReportFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <MonthlySalaryReportTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Monthly Salary Payable Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <MonthlySalaryReportTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default MonthlySalaryReport;